import { liteClient } from 'algoliasearch/lite'

let searchClient
let searchConfig

export const getSearchConfig = () => {
    if (searchConfig) return searchConfig

    const { dataset } = document.body
    searchConfig = {
        provider: dataset.searchProvider,
        appId: dataset.algoliaAppId,
        searchKey: dataset.algoliaSearchKey,
        indexName: dataset.algoliaIndex,
        querySuggestionsIndexName: dataset.algoliaSuggestionsIndex,
    }

    return searchConfig
}

// Both browser search surfaces import this getter, so they share one lite client.
export const getSearchClient = () => {
    if (searchClient) return searchClient

    const { provider, appId, searchKey, indexName } = getSearchConfig()
    if (provider !== 'algolia' || !appId || !searchKey || !indexName) return null

    searchClient = liteClient(appId, searchKey)
    return searchClient
}
